import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useHistory } from "react-router-dom";
import { requestLogin } from '../../store/actionCreators/authentication';
import { default as ManualLogin } from './ManualLogin';

const AutoLogin = () => {
    const { skinId, username, token } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const doAutoLogin = skinId && username && token;


    useEffect(() => {
        if (doAutoLogin) {
            dispatch(requestLogin({ skinId, username, token }));
            history.push(`/home`);
        }
    }, []);

    return (
        <div>
            {doAutoLogin ? '' : <ManualLogin />}
        </div>
    );
};

export default AutoLogin;
